export const CRIME_SECTIONS = [
  { id: "calls-for-service", label: "Calls for Service" },
  { id: "offenses", label: "Offenses" },
  { id: "crime-trends", label: "Crime Trends" },
  { id: "police-blotter", label: "Police Blotter" },
  { id: "stolen-vehicle-list", label: "Stolen Vehicle List" },
  { id: "stolen-vehicle-trends", label: "Stolen Vehicle Trends" },
];

export const DEFAULT_CRIME_SECTION = "offenses";

export function crimeSectionFromSearch(search = "") {
  const requested = new URLSearchParams(search).get("section");
  return CRIME_SECTIONS.some((section) => section.id === requested)
    ? requested
    : DEFAULT_CRIME_SECTION;
}

export function crimeSectionHref(sectionId) {
  return `/crime?section=${encodeURIComponent(sectionId)}`;
}
